import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Grid from '@material-ui/core/Grid';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import AddPhotoIcon from '@material-ui/icons/AddPhotoAlternate';
import DeleteIcon from '@material-ui/icons/Delete';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import environment from '../environments';
import { observer } from "mobx-react";
import 'react-trumbowyg/dist/trumbowyg.min.css'

const styles = theme => ({
  root: {
    width: '100%',
    padding: theme.spacing.unit * 3,
    backgroundColor: theme.palette.background.paper,
  },
  button: {
    fullWidth: true,
    margin: theme.spacing.unit,
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  gridListTileBar: {
    background: 'none'
  },
  icon: {
    color: 'black'
  },
  buttonWrapper: {
    margin: theme.spacing.unit,
    position: 'relative',
  },
  buttonProgress: {
    color: 'black',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  }
});


class StickerPhotos extends Component {

  constructor(props) {
    super(props);
    this.handleSetStickerFavoriteClick = this.handleSetStickerFavoriteClick.bind(this);
    this.handleDeleteStickerPhotoClick = this.handleDeleteStickerPhotoClick.bind(this);
    this.handleAddStickerPhotoClick = this.handleAddStickerPhotoClick.bind(this);
    this.handleOpenImageClick = this.handleOpenImageClick.bind(this);
  }

  handleSetStickerFavoriteClick(uuid) {
    this.props.stickerStore.setStickerFavorite(this.props.match.params.id, uuid);
  }

  handleDeleteStickerPhotoClick(uuid) {
    this.props.stickerStore.deleteStickerPhoto(this.props.match.params.id, uuid);
  }

  handleAddStickerPhotoClick(event) {
    this.props.stickerStore.addStickerPhoto(this.props.match.params.id, event.target.files[0])
  }

  handleOpenImageClick(photoUrl) {
    this.props.stickerStore.photoModalOpen = true;
    this.props.stickerStore.photoUrl = photoUrl;
  }

  handleClose = () => {
    this.props.stickerStore.photoModalOpen = false;
    this.props.stickerStore.photoUrl = "";
  }

  componentDidMount() {
    this.props.stickerStore.getStickerPhotos(this.props.match.params.id);
  }

  render() {
    const { classes } = this.props;
    
    return (
      <div className={classes.root}>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.props.stickerStore.photoModalOpen}
          onClose={this.handleClose}
          style={{display:'flex',alignItems:'center',justifyContent:'center'}}
          >
            <img style={{maxWidth: '100%'}} src={this.props.stickerStore.photoUrl} alt="Vollbild" />
        </Modal>
        <Grid container spacing={24}>
          <Grid item xs={12} lg={6}>
            <Typography variant="h6" gutterBottom>
              Fotos
            </Typography>
            <GridList cellHeight={180} className={classes.gridList}>
            {this.props.stickerStore.stickerPhotos.map((stickerPhoto, index) => (
              <GridListTile key={stickerPhoto.uuid} cols={1}>
                <img src={environment.CDN_HOST + "/" + stickerPhoto.photo_key} alt={stickerPhoto.uploaded} onClick={this.handleOpenImageClick.bind(this, environment.CDN_HOST + "/" + stickerPhoto.photo_key)}/>
                <GridListTileBar
                  className={classes.gridListTileBar}
                  titlePosition="top"
                  actionPosition="left"
                  actionIcon={
                    <IconButton className={classes.icon} onClick={this.handleSetStickerFavoriteClick.bind(this, stickerPhoto.uuid)}>
                      {(stickerPhoto.is_profile === 1) ? (
                        <StarIcon />
                      ) : (
                        <StarBorderIcon />
                      )}
                    </IconButton>
                  }
                />
                <GridListTileBar
                  className={classes.gridListTileBar}
                  titlePosition="bottom"
                  actionPosition="right"
                  actionIcon={
                    <IconButton className={classes.icon} onClick={this.handleDeleteStickerPhotoClick.bind(this, stickerPhoto.uuid)}>
                        <DeleteIcon />
                    </IconButton>
                  }
                />
              </GridListTile>
            ))}
          </GridList>
          </Grid>
        </Grid>
        <hr />
        <Grid container direction="column" spacing={24} style={{marginTop: "20px"}}>
        {(this.props.stickerStore.stickerPhotos.length < 4) ? (
          <Grid item xs={12} lg={6}>
            <input
              accept="image/*"
              style={{ display: 'none' }}
              id="file-upload-button"
              type="file"
              onChange={this.handleAddStickerPhotoClick.bind(this)}
            />
            <label htmlFor="file-upload-button" style={{width: '100%'}}>
              <div className={classes.buttonWrapper}>
                <Button variant="contained" component="span" color="secondary" fullWidth disabled={this.props.stickerStore.uploadingPhoto}>
                 <AddPhotoIcon className={classes.leftIcon}/>
                  Foto hochladen
                </Button>
                {this.props.stickerStore.uploadingPhoto && <CircularProgress size={24} className={classes.buttonProgress} />}
              </div>
            </label> 
          </Grid>
        ) : (
          <div>
            <Typography variant="body2" align="center" style={{color: 'grey'}}>
                Sie haben bereits 4 Fotos hochgeladen. Um ein neues Foto hochladen zu können, muss ein vorhandenes Foto gelöscht werden.
            </Typography>
          </div>
        )}
        </Grid>
        </div>
    );
  }
}

export default withStyles(styles)(observer(StickerPhotos));
